import { useState } from "react";
import { DerogationEditor } from "@/components/DerogationEditor";

// EBCI runway operating hours (local time). Flights scheduled outside need a derogation.
const OPEN = "06:30";
const CLOSE = "23:00";

export const needsDerogation = (flight) => {
  const t = (flight?.time || "").trim();
  if (!/^\d{2}:\d{2}$/.test(t)) return false;
  const atEbci = (flight?.origin || "").toUpperCase() === "EBCI" || (flight?.destination || "").toUpperCase() === "EBCI";
  if (!atEbci) return false;
  return t < OPEN || t > CLOSE;
};

export const DerogationBadge = ({ flight }) => {
  const [open, setOpen] = useState(false);
  if (!needsDerogation(flight)) return null;

  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        data-testid={`derogation-badge-${flight?.id || flight?.registration || ""}`}
        className="px-3 py-1 bg-red-600 hover:bg-red-700 text-white text-xs font-bold rounded-full whitespace-nowrap transition-colors cursor-pointer"
        title="Scheduled outside EBCI runway hours (06:30–23:00) — derogation required"
      >
        Ask Derogation
      </button>
      {open && <DerogationEditor flight={flight} open={open} onClose={() => setOpen(false)} />}
    </>
  );
};
